import {gql} from "@irati/utils/gql"
import fullPaymentOrder from "@irati/payments/services/fragments/fullPaymentOrder"
import fullBasket from "./fullBasket"

const partialCheckoutRedemption = gql`
  fragment partialCheckoutRedemption on CheckoutRedemption {
    dateUnix
    isUsed
    uuid
    type
    metadata {
      createdAt
    }
    dealSnapshot {
      uuid
      type
      bannerImage
      description
      emailRequired
      header
      importantInfo
      cardImage
      internalIdentifier
      location {
        city
      }
      redemptionInstructions
      termsAndConditions
      thumbnailImage
      typeHighlight
      savings {
        userSavings {
          header
          type
          value
        }
      }
      externalLinks {
        web
      }
      isTTDeal
      productConfig {
        products {
          data {
            externalMetadata {
              openValue
            }
          }
          salePrice {
            currency
            discount
            value
          }
        }
      }
    }
    order {
      uuid
      paymentId
      paymentOrder {
        ...fullPaymentOrder
      }
      totals {
        total {
          value
          currency
        }
        totalBeforeDiscount {
          value
          currency
        }
        totalVAT {
          value
          currency
        }
      }
      products {
        product {
          uuid
          name
        }
        items {
          uuid
          code
          expiry
          pin
          status
          type
          poNumber
        }
      }
      basket {
        ...fullBasket
      }
    }
  }

  ${fullPaymentOrder}
  ${fullBasket}
`

export default partialCheckoutRedemption
